/* eslint-disable no-console */
export const filterSelectOptions = (e: string, option: any): boolean => {
  if (option !== undefined) {
    return (
      option?.label?.toString().toLowerCase().includes(e.toLowerCase()) ?? false
    );
  } else {
    return false;
  }
};
